export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

const base =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-display font-semibold uppercase tracking-[0.12em] transition-[background-color,border-color,color,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice disabled:pointer-events-none disabled:opacity-40';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-marine text-white hover:bg-[#3d9bff]',
  secondary: 'border border-titanium/30 text-white hover:border-white hover:bg-white/5',
  ghost: 'text-titanium hover:text-white',
};

export function buttonClasses(variant: ButtonVariant = 'primary', size: 'md' | 'lg' = 'md') {
  const s = size === 'lg' ? 'h-14 px-8 text-[16px]' : 'h-12 px-6 text-[15px]';
  return `${base} ${variants[variant]} ${s}`;
}
